























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import DropDown from '../mixins/Dropdown1'

@Component
export default class SearchScreen extends Mixins(DropDown) {
  @Prop({ default: () => ({ ID: '', NAME: '全城' }) }) readonly value: any
  @Prop({ default: [] }) readonly listData!: any //全部筛选项
  @Prop({ default: '' }) readonly title!: string //全部筛选项
}
